import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loginUser } from './actions';
import LoginForm from './LoginForm';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE } from './actions';
import { updateSelectedCenter } from '../dashboard/actions';

class Login extends React.Component {

	componentWillReceiveProps(nextProps) {
		if (!this.props.isAuthenticated && nextProps.isAuthenticated) {
			if (nextProps.centerId > 0) { // update parent's center if parent has selected a center on public timetable
				const { centerId, history, updateSelectedCenter } = nextProps;
				updateSelectedCenter(centerId, history, false);
			}
		}
	}

	render() {
		const { from } = this.props.location.state || {
			from: {
				pathname: this.props.programId ? '/booking/child' : this.props.bookingDate ? '/individual-consultation/booking/child' : '/',
				search: this.props.programId ? '?select=true' : ''
			}
		};

		if (this.props.isAuthenticated) {
			return <Redirect to={from} />;
		}

		const { t } = this.props;

		return (
			<div className='franchise-portal'>
				<ReduxBlockUi block={LOGIN_REQUEST} unblock={[LOGIN_SUCCESS, LOGIN_FAILURE]}>
					<div className='box-login'>
						<p>{t('FO_Login_Text')}</p>
						<LoginForm onSubmit={this.props.loginUser} from={from} />
					</div>
				</ReduxBlockUi>
			</div>
		);
	}
}

Login.propTypes = {
	loginUser: PropTypes.func,
	location: PropTypes.object,
	isAuthenticated: PropTypes.bool,
	errors: PropTypes.array
};

const mapStateToProps = state => {
	const { booking: { programId, centerId, date } } = state;
	return {
		...state.auth,
		programId,
		centerId,
		bookingDate: date,
	};
};

export default connect(mapStateToProps, {
	loginUser,
	updateSelectedCenter
})(withTranslation()(Login));